export const state = () => ({
  lookedUpUser: {
    email: null,
    hasPhoneNumber: null,
    shouldBeAskedForRecoveringSetup: null
  },
  loginOrigin: null
})

export const getters = {
  lookedUpUser(state, getters, rootState) {
    return state.lookedUpUser
  },
  loginOrigin(state, getters, rootState) {
    return state.loginOrigin
  }
}

export const mutations = {
  updateLookedUpUser(state, lookedUpUser) {
    state.lookedUpUser = lookedUpUser
  },

  shouldBeAskedForRecoveringSetup(state, should) {
    state.lookedUpUser.shouldBeAskedForRecoveringSetup = should
  },

  updateLoginOrigin(state, loginOrigin) {
    state.loginOrigin = loginOrigin
  }
}
